import { TFunction } from "i18next";
import { CalendarItem, CalendarItemType } from "../useCalendarView";
import { toZonedTime } from "date-fns-tz";
import { formatDate } from "date-fns";
import { getMultilingualString } from "shared/utils";
import _ from "lodash";

export function getCalendarItemTitles(
  item: CalendarItem,
  t: TFunction<"storefront", "CALENDAR">,
  allProductsCount: number,
) {
  const isStartAndEndDateSameMonth =
    toZonedTime(item.startDate, "UTC").getMonth() ===
    toZonedTime(item.endDate, "UTC").getMonth();

  const dateString = `${formatDate(toZonedTime(item.startDate, "UTC"), "MMM dd")} - ${formatDate(toZonedTime(item.endDate, "UTC"), isStartAndEndDateSameMonth ? "dd" : "MMM dd")}`;

  switch (item.type) {
    case CalendarItemType.Order: {
      return {
        title: item.customerName ?? "",
        subtitle: _.compact([
          getMultilingualString(item.productName ?? {}),
          dateString,
          t("ITEMS.GUEST", { count: item.guests }),
        ]).join(" • "),
      };
    }
    case CalendarItemType.Closure: {
      const isClosureForAllProducts =
        (item.closureProducts?.length ?? 0) === allProductsCount;

      return {
        title: item.closureName ?? "",
        subtitle: _.compact([
          ...(!isClosureForAllProducts
            ? (item.closureProducts ?? []).map(product =>
                getMultilingualString(product.name),
              )
            : [t("ITEMS.ENTIRE_STOREFRONT")]),
          dateString,
        ]).join(" • "),
      };
    }
    case CalendarItemType.EventSale: {
      const sessionDateStr = formatDate(
        toZonedTime(item.startDate, "UTC"),
        "MMM dd, yyyy",
      );
      const passes = item.passesSold ?? 0;
      const tickets = item.ticketsSold ?? 0;
      const soldParts = _.compact([
        passes > 0 ? t("ITEMS.PASSES_SOLD", { count: passes }) : null,
        tickets > 0 ? t("ITEMS.TICKETS_SOLD", { count: tickets }) : null,
        passes + tickets > 0
          ? t("ITEMS.ARRIVED_COUNT", {
              arrived: item.arrivedCount ?? 0,
              total: passes + tickets,
            })
          : null,
      ]);
      return {
        title: item.eventName ?? "",
        subtitle: _.compact([sessionDateStr, ...soldParts]).join(" • "),
      };
    }
    default:
      return {
        title: "",
        subtitle: "",
      };
  }
}